<template>
  <div class="flex relative">
    <div
      v-clickOutside="close"
      class="flex flex-wrap items-center text-14 text-blue- cursor-pointer"
      @click="showDropdown"
    >
      <div
        v-if="selectedProject"
        class="flex items-center text-brand bg-project hover:bg-project-hover anim-color px-10 py-4 rounded-8 leading-tight"
      >
        <p class="mr-10 text-13 truncate">@{{ selectedProject.title }}</p>
        <i class="icon-close text-10 opacity-50 hover:opacity-100 anim-opacity mt-2" @click.stop="unselectProject" />
      </div>
      <ButtonModule
        v-else
        text="+ @pagelink"
        class="text-brand bg-project hover:bg-project-hover anim-color px-10 py-4 text-13 rounded-8"
      />
    </div>

    <InfoDropdown v-if="show" hide-scroll class="absolute top-full z-50" classes=" -mt-1">
      <div class="mt-0">
        <input
          ref="inputRef"
          v-model="filterValue"
          placeholder="search"
          class="w-full rounded text-14 bg-transparent outline-none px-12 mb-8"
          maxlength="12"
          type="text"
          @click.stop
        >
        <div class="max-h-235 overflow-y-auto no-scroll-bar">
          <div
            v-for="project in filteredProjects"
            :key="project.id"
            class="text-15 flex items-center w-full cursor-pointer hover:bg-selection px-12 py-5"
            :class="{'bg-project-hover': isSelected(project.id)}"
            @click.stop="setProject(project)"
          >
            <div class="flex items-center w-full">
              <img v-if="project.icon" class="w-20 h-20 mr-10" :src="require(`@/assets/images/icons/${project.icon}.png`)" alt="icon">
              <img v-else-if="project.icon === null" class="w-20 h-20 mr-10" src="@/assets/images/icons/purple_circle.png" alt="icon">
              <p>{{ project.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </InfoDropdown>
  </div>
</template>

<script>
import InfoDropdown from '@/components/shared/InfoDropdown'
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default defineComponent({
  components: { InfoDropdown, ButtonModule },

  props: {
    modelValue: Object
  },

  emits: ['update:modelValue'],

  setup (props, { emit }) {
    const { getters, state } = useStore()

    const show = ref(false)
    const inputRef = ref(null)

    const selectedProject = ref(props.modelValue)
    const filterValue = ref('')

    const isDarkMode = computed(() => getters.isDarkMode)
    const isMagenta = computed(() => getters.isMagenta)
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')
    const isPoseidonTheme = computed(() => state.settings.settings.theme === 'Poseidon')

    const isSelected = computed(() => (id) => selectedProject.value?.id === id)

    const filteredProjects = computed(() => {
      if (filterValue.value.trim() !== '') {
        return state.project.projects.filter(item => item.title.toLowerCase().match(filterValue.value.toLowerCase()))
      } else {
        return state.project.projects
      }
    })

    function showDropdown () {
      show.value = !show.value
      setTimeout(() => {
        if (show.value) {
          inputRef.value.focus()
        }
      }, 100)
    }

    function close () {
      show.value = false
      filterValue.value = ''
    }

    function setProject (project) {
      close()
      selectedProject.value = project
      emit('update:modelValue', project)
    }

    function unselectProject (id) {
      selectedProject.value = null
      emit('update:modelValue', null)
    }

    return {
      // refs
      inputRef,
      // data
      show,
      filterValue,
      selectedProject,
      // computeds
      filteredProjects,
      isPoseidonTheme,
      isDraculaTheme,
      isSelected,
      isDarkMode,
      isMagenta,
      // functions
      close,
      setProject,
      showDropdown,
      unselectProject
    }
  }
})
</script>
